const ACTION_GET_ENERGY_SAVING_LIST = 'ACTION_GET_ENERGY_SAVING_LIST'
const ACTION_GET_ENERGY_SAVING_LIST_SUCCESS = 'ACTION_GET_ENERGY_SAVING_LIST_SUCCESS'
const ACTION_GET_ENERGY_SAVING_RESET = 'ACTION_GET_ENERGY_SAVING_RESET'

export {
  ACTION_GET_ENERGY_SAVING_LIST,
  ACTION_GET_ENERGY_SAVING_LIST_SUCCESS,
  ACTION_GET_ENERGY_SAVING_RESET,
}
